import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiService} from './api.service';
import {Response} from '../interfaces/';
import {Observable, of} from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable()
export class SupplyService {

  constructor(private http: HttpClient, private API: ApiService) {
  }

  listSupplies(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.listSupplies, data);
  }

  listPiePagina(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.listPiePagina, data);
  }

  listModalCargar(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.listModalCargar, data);
  }

  listTiposDeposito(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.listTiposDeposito, data);
  }

  detailSupply(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.detailSupply, data);
  }

  detailSupplyRuc(data: any): Observable<Response> {
    return this.http.post<Response>(this.API.detailSupplyRuc, data);
  }

  obtenerGrafico(element: any): Observable<Response> {
    return this.http.post<Response>(this.API.historicalConsumption, element);
  }

  validarCorreo(body: any): Observable<any> {
    if (!environment.prueba){
      let httpParams = new HttpParams();
      httpParams = httpParams.append('url', environment.urlValidacionCorreo);
      return this.http.post(this.API.validaCorreo, body, { params: httpParams });
    } 
    else {
      return of({bRESP: {data: {codigoVerificacion: "1234"}}});
    }
  }

  validarCelular(body: any): Observable<any> {
    if (!environment.prueba){
      let httpParams = new HttpParams();
      //httpParams = httpParams.append('url', environment.urlValidacionCorreo);
      httpParams = httpParams.append('celular', body.celular);
      //console.log("httpParams: ", httpParams);

      return this.http.post(this.API.validacelular, body, { params: httpParams });
    } 
    else {
      return of({bRESP: {data: {codigoVerificacion: "1234"}}});
    }
  }

}
